import React from 'react';
import AnalysisPageLayout from '../../components/aesthetic/AnalysisPageLayout';
import ImageUpload from '../../components/aesthetic/ImageUpload';
import BeforeAfterComparison from '../../components/aesthetic/BeforeAfterComparison';
import NoseAnalysisResults from '../../components/aesthetic/NoseAnalysisResults';
import LoadingOverlay from '../../components/aesthetic/LoadingOverlay';
import ErrorBanner from '../../components/aesthetic/ErrorBanner';
import EmptyState from '../../components/aesthetic/EmptyState';
import { useNoseAnalysis } from '../../hooks/useNoseAnalysis';

function NoseAnalysis() {
  const {
    beforePreview,
    afterPreview,
    fieldErrors,
    error,
    loading,
    results,
    handleImageChange,
    handleAnalyze,
  } = useNoseAnalysis();

  return (
    <AnalysisPageLayout
      title="Nose Analysis"
      subtitle="Compare before and after rhinoplasty images to measure width, projection, and symmetry improvements."
    >
      {loading && <LoadingOverlay message="Running nose analysis…" />}

      <section className="aesthetic-section">
        <h2 className="aesthetic-section-title">Upload Images</h2>
        <ErrorBanner message={error} />
        <div className="upload-form-grid">
          <ImageUpload
            label="Before Image"
            preview={beforePreview}
            onChange={(file) => handleImageChange('before', file)}
            error={fieldErrors.before}
          />
          <ImageUpload
            label="After Image"
            preview={afterPreview}
            onChange={(file) => handleImageChange('after', file)}
            error={fieldErrors.after}
          />
        </div>
        <div className="upload-form-actions">
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleAnalyze}
            disabled={loading}
          >
            Analyze
          </button>
        </div>
      </section>

      {!results && !loading && (
        <section className="aesthetic-section">
          <EmptyState
            title="No analysis results yet"
            description="Upload before and after nose images, then click Analyze to view width, projection, and symmetry metrics."
          />
        </section>
      )}

      {results && (
        <>
          <section className="aesthetic-section">
            <h2 className="aesthetic-section-title">Analytics Dashboard</h2>
            <NoseAnalysisResults results={results} loading={false} error="" />
          </section>

          <section className="aesthetic-section">
            <h2 className="aesthetic-section-title">Before / After Comparison</h2>
            <BeforeAfterComparison
              beforeImage={beforePreview}
              afterImage={afterPreview}
            />
          </section>
        </>
      )}
    </AnalysisPageLayout>
  );
}

export default NoseAnalysis;
